'use strict';

module.exports = {
    'gJQLBEeKNVTfjh@': {
        'name': 'tertiary alcohol'
    },
    'eF@HxP': {
        'name': 'alkyne'
    },
    'eF@HhP': {
        'name': 'alkene'
    },
    'eM`BN`p`': {
        'name': 'secondary amine'
    },
    'gC``@deZ@~d\\': {
        'name': 'ester'
    },
    'eMHBN``': {
        'name': 'ether'
    },
    'gC``Adij@pf}IX': {
        'name': 'hemiacetal'
    },
    'gJP`AdizhCzRp': {
        'name': 'acetal'
    },
    'gCh@AGj@`': {
        'name': 'tertiary amine'
    },
    'gJP`AdizhCzQp': {
        'name': 'cetal'
    },
    'gJP`AdizhCzSP': {
        'name': 'acetal'
    },
    'gJY@DDefhCzQp': {
        'name': 'tertiary amide'
    },
    'eMJDVTfP@': {
        'name': 'aldehyde'
    },
    'gCaDLEeKJST`@': {
        'name': 'ketone'
    },
    'eF`BLFD@': {
        'name': 'primary amine'
    },
    'eFHBLFD@': {
        'name': ''
    },
    'eMJDVTf`@': {
        'name': 'primary alcohol'
    },
    'gCaDLEeKJSU@@': {
        'name': 'secondary alcohol'
    },
    'eMDARVCB_Tx': {
        'name': 'carboxylic acid'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/extend/functions.js
// module id = 42
// module chunks = 0